<template>
  <div role="dialog"
       class="confirmation-popup"
       v-if="getConfData.showPopup"
       @click.self.prevent="clearAction">
    <div class="confirmation-popup-inner"
         id="alertPopup"
         aria-labelledby="confirmation-popup-title"
         aria-modal="true">
      <h2 class="confirmation-popup-inner-caption" id="confirmation-popup-title">
        <span>{{ this.getActionNotifyText(getConfData.actionName, getConfData.userStatus)['title'] }}</span>
      </h2>
      <div class="confirmation-popup-inner-body">
        <span>{{ this.getActionNotifyText(getConfData.actionName, getConfData.userStatus)['body'] }}</span>
        <div class="confirmation-popup-inner-body__form" v-if="getConfData.includeForm">
          <textarea class="form-control form-control__textarea"
                    v-model="getConfData.feedbackText"></textarea>
        </div>
      </div>
      <div class="confirmation-popup-inner-controll-panel">
        <button type="button" @click="clearAction">{{ getConfData.customCancelButtonText || 'No, cancel' }}</button>
        <button type="button" @click.prevent.stop="confirmAction">{{ getConfData.customConfirmButtonText || 'Yes, proceed' }}</button>
      </div>
      <button class="confirmation-popup-close"
              aria-label="Close dialog"
              @click.self.prevent="clearAction"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'conf-popup',
  data () {
    return {
      nonMenuNodes: {}
    }
  },
  computed: {
    ...mapGetters([
      'getConfData'
    ])
  },
  methods: {
    ...mapActions([
      'clearConfAction',
      'confCurAction'
    ]),
    getActionNotifyText (action, status) {
      let data = []
      switch (action) {
        case 'removeProfile':
          data['title'] = 'Are you sure you want to delete your profile?'
          data['body'] = 'You will be removed from the system and your access to Clear Assured will be blocked. You can’t undo delete, you will not be able to access the system unless someone creates a new account for you.'
          break

        case 'removeUserById':
          data['title'] = 'Are you sure you want to delete this user?'
          data['body'] = 'Deleted users are removed from the system and can’t be reinstated. A good alternative to delete is archiving a user.'
          break

        case 'changeUserStatus':
          if (status === 0) {
            data['title'] = 'Are you sure you want to archive this user?'
            data['body'] = 'Archived users will still appear in your organization, but they will not be able to access the application. You can unarchive a user and re-enable their access at any time.'
          }

          if (status === 1) {
            data['title'] = 'Are you sure you want to re-enable this user?'
            data['body'] = 'This will grant the user access to the application. Viewing rights and privileges depend on their user type (role).'
          }
          break

        case 'removeCompanyById':
          data['title'] = 'Are you sure you want to delete this company?'
          data['body'] = 'Please note this action will permanently delete the company and all the users associated with it. There will be no possibility to undo this action.'
          break

        case 'removeIndustryById':
          data['title'] = 'Are you sure you want to delete this industry?'
          data['body'] = 'Please note this action will permanently delete the industry. There will be no possibility to undo this action.'
          break

        case 'removeArticleById':
          data['title'] = 'Are you sure you want to delete this resource?'
          data['body'] = 'By doing this, the resource will be permanently removed from the server with no possibility to undo.'
          break

        case 'removeCategoryById':
          data['title'] = 'Are you sure you want to delete this category?'
          data['body'] = 'Please note this action will permanently delete the resource. There will be no possibility to undo this action.'
          break

        case 'removeChapterById':
          data['title'] = 'Are you sure you want to delete this chapter?'
          data['body'] = 'Please note this action will permanently delete the chapter. There will be no possibility to undo this action.'
          break

        case 'removePromotionById':
          data['title'] = 'Are you sure you want to delete this promotion?'
          data['body'] = 'Please note this action will permanently delete the promotion. There will be no possibility to undo this action.'
          break

        case 'removeTagById':
          data['title'] = 'Are you sure you want to delete this topic?'
          data['body'] = 'Please note this action will permanently delete the resource. There will be no possibility to undo this action.'
          break

        case 'resetStyles':
          data['title'] = 'Are you sure you want to reset industry styles to default?'
          data['body'] = 'Please note this action will permanently remove industry colors and custom logo. There will be no possibility to undo this action.'
          break

        case 'changeCompanyStatus':
          if (status === 0) {
            data['title'] = 'Are you sure you want to archive this company?'
            data['body'] = 'By doing this, you will keep the company in the database, but access will be blocked for all users associated with it.'
          }

          if (status === 1) {
            data['title'] = 'Are you sure you want to re-enable this company?'
            data['body'] = 'By doing this, all active users associated with it will be granted access to the application.'
          }

          break

        case 'changeArticleStatus':
          if (status === 1) {
            data['title'] = 'Are you sure you want to archive this resource?'
            data['body'] = 'By doing this, the resource will no longer appear in searches nor will it be visible to non-admin users.'
          }

          if (status === 0) {
            data['title'] = 'Are you sure you want to restore this resource?'
            data['body'] = 'By doing this, the resource will start appearing in search results and it be visible to non-admin users.'
          }

          break

        case 'changeCompanyUrl':
          data['title'] = 'Are you sure you want to change the company url?'
          data['body'] = 'You should avoid changing the company URL after users have been added to a company. When invited to join, users get a link to their company URL. If you change the URL, they will be redirected to the 404 error page.'
          break

        case 'noAllowedEmailDomains':
          data['title'] = 'Email address confirmation'
          data['body'] = 'Your company has not defined which email domains it allows users from in Clear Assured. This means you can invite users with any email extension to work in the application. For security reasons we recommend you set up the approved domains in your Company setup.'
          break

        case 'deleteStatusFile':
          data['title'] = 'Are you sure you want to delete this file?'
          data['body'] = 'The file will no longer be available for download and you will not be able to undo this action.'
          break

        case 'deleteStatusMessage':
          data['title'] = 'Are you sure you want to cancel this comment?'
          data['body'] = 'It will continue to appear in the list, but it will be hidden and marked as cancelled. You will not be able to undo this action.'
          break

        case 'deleteStatusFileMessage':
          data['title'] = 'Are you sure you want to cancel this comment and delete all the files attached to it?'
          data['body'] = 'The comment will continue to appear in the list, but it will be hidden and marked as cancelled. The file(s) will no longer be available for download.  You will not be able to undo this action.'
          break

        case 'impersonateUserById':
          let userData = JSON.parse(localStorage.getItem('userData'))
          let user = ''
          if (userData) {
            user = userData['firstName'] + ' ' + userData['lastName']
          }
          data['title'] = 'Are you sure you want to perform this action?'
          data['body'] = 'You are about to impersonate ' + this.getConfData.actionId + '. Please remember that your actions will produce results that will be associated with the impersonated user, yet the application logs will show your actions as being done while impersonated by ' + user + '.'
          break

        case 'resetEmailTemplate':
          data['title'] = 'Are you sure you want to reset this email template to default?'
          data['body'] = 'You can always go back and customise it again, but all changes done prior to the reset will be lost.'
          break

        case 'editLanding':
          data['title'] = 'Are you sure you want to edit this landing?'
          data['body'] = 'Please be aware that the changes made on this landing will be applied to all company landings from the current industry.'
          break

        case 'removeRedirectById':
          data['title'] = 'Are you sure you want to delete this redirect?'
          data['body'] = 'Please note this action will permanently delete the redirect. There will be no possibility to undo this action.'
          break

        case 'sendTasksFeedback':
          data['title'] = 'Send us your feedback'
          data['body'] = 'Please tell us what you think about Clear Assured: is everything working well, would you like to improve something, what do you like best about it and what don’t you like?'
          break

        case 'resetTaskHistoryById':
          data['title'] = 'Are you sure you want to reset this company’s progress?'
          data['body'] = 'There is no ‘undo’ to this. Once you hit ‘Yes’ it will all be gone. \nPlease be aware that these actions are being logged!'
          break

        case 'resetTaskMessagesById':
          data['title'] = 'Are you sure you want to reset this company’s tasks conversations?'
          data['body'] = 'There is no ‘undo’ to this. Once you hit ‘Yes’ it will all be gone. Please be aware that these actions are being logged!'
          break

        case 'suggestTopic':
          data['title'] = 'Suggest a topic'
          data['body'] = 'Please tell us the name of the topic you\'re looking for, what resources should it include and why do you think it would be a good addition to Clear Assured.'
          break

        case 'disconnectFromBilling':
          data['title'] = 'Are you sure you want to disconnect this company from billing?'
          data['body'] = 'This company has active billing subscriptions in Stripe. Please note this action will permanently delete them too.'
          break

        case 'disconnectFromBillingError':
          data['title'] = 'Are you sure you want to disconnect this company from billing?'
          data['body'] = this.getConfData.customText || ''
          break

        case 'disconnectCompanyFromBilling':
          data['title'] = 'Are you sure you want to cancel your subscription?'
          data['body'] = 'If you click yes, your subscription will be cancelled at the end of your commitment period and past that point all the users under this subscription will lose their access to Clear Assured.'
          break

        default:
          data['title'] = 'Are you sure you want to perform this action?'
          data['body'] = ''
          break
      }

      return data
    },
    confirmAction () {
      this.getConfData.actionConfirmed = true
      // this.clearConfAction()
    },
    clearAction () {
      let h1 = document.getElementsByTagName('H1')
      if (h1.length) {
        h1[0].setAttribute('tabindex', '-1')
        h1[0].focus()
      }
      this.getConfData.showPopup = false
      Object.keys(this.getConfData).forEach((key) => {
        if (key !== 'isShown' && key !== 'style' && key !== 'id') {
          this.getConfData[key] = null
        }
      })
    }
  },
  watch: {
    'getConfData.showPopup' (value) {
      if (value === true) {
        setTimeout(function () {
          let alert = document.getElementById('alertPopup')
          if (alert) {
            alert.setAttribute('tabindex', '-1')
            alert.focus()
          }
        }, 500)
      }
      let self = this
      if (Array.from) {
        const popupNodes = Array.from(document.querySelectorAll('#app, .w1, .wrap-admin, .confirmation-popup, .confirmation-popup-inner, ' +
          '.confirmation-popup-inner-caption, .confirmation-popup-inner-caption > span, .confirmation-popup-inner-body, ' +
          '.confirmation-popup-inner-body > span, .confirmation-popup-inner-controll-panel, ' +
          'confirmation-popup-inner-controll-panel > button, .confirmation-popup-close'))
        if (value === true) {
          for (let i = 0; i < self.nonMenuNodes.length; i++) {
            const node = self.nonMenuNodes[i]
            if (!popupNodes.includes(node)) {
              node._prevTabindex = node.getAttribute('tabindex')
              node._prevAriaHidden = node.getAttribute('aria-hidden')
              node.setAttribute('tabindex', -1)
              node.setAttribute('aria-hidden', 'true')
              node.style.outline = 'none'
            }
          }
        } else {
          for (let i = 0; i < self.nonMenuNodes.length; i++) {
            const node = self.nonMenuNodes[i]
            if (node._prevTabindex) {
              node.setAttribute('tabindex', node._prevTabindex)
              node._prevTabindex = null
            } else {
              node.removeAttribute('tabindex')
            }
            if (node._prevAriaHidden) {
              node.setAttribute('aria-hidden', node._prevAriaHidden)
              node._prevAriaHidden = null
            } else {
              node.removeAttribute('aria-hidden')
            }
            node.style.outline = null
          }
        }
      }
    }
  },
  mounted () {
    this.nonMenuNodes = document.querySelectorAll('body *:not([tabindex="-1"]):not([aria-hidden="true"])' +
    ':not(.confirmation-popup):not(.confirmation-popup-inner):not(.confirmation-popup-inner-caption)' +
    ':not(.confirmation-popup-inner-body):not(.confirmation-popup-inner-controll-panel)' +
    ':not(.confirmation-popup-close)')
  }
}
</script>

<style src="@/assets/scss/components/conf-popup.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// ConfPopup.vue?7dcf2c55